import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import routes from "../../constants/routes";
import { PageHeader, PageRoot } from "../../components";
import DetailGrid from "../../components/details/DetailGrid";
import { LegalEntity } from "../../constants/interfaces";
import { legalEntityActions } from "../../reducers/legalEntity";
import { searchTableData } from "../../utils/table";
import { Card, Typography } from "@material-ui/core";
import { Classes } from "jss";

const styles = (theme: Theme) =>
  createStyles({
    noResults: {
      padding: theme.spacing(4)
    }
  });

type State = {
  filteredEntities: LegalEntity[];
  searchTerm: string;
};

type Props = RouteComponentProps & {
  classes: Classes;
  legalEntities: LegalEntity[];
  getLegalEntities: () => Promise<void>;
  loading: boolean;
};

class MyLegalEntities extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filteredEntities: [],
      searchTerm: ""
    };
    this.formatDetails = this.formatDetails.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    this.props.getLegalEntities();
  }

  formatDetails(legalEntities: LegalEntity[]) {
    return legalEntities.map(legalEntity => ({
      id: legalEntity.cmAcmCaseIdentifier,
      title: legalEntity.legalEntityName,
      listItems: [
        {
          icon: "business",
          label: `${legalEntity.premisesCount} premises`
        }
      ],
      onView: () =>
        this.props.history.push(
          `${routes.MY_LEGAL_ENTITY.url}${legalEntity.cmAcmCaseIdentifier}`
        )
    }));
  }

  onSearch(searchTerm: string) {
    const filteredEntities = searchTableData(
      searchTerm,
      // Will return results (partially) matching either legal entity name
      ["legalEntityDescriptor", "legalEntityName"],
      this.props.legalEntities
    );
    this.setState({
      searchTerm: searchTerm.trim(),
      filteredEntities
    });
  }

  render() {
    const { classes, legalEntities } = this.props;
    const { filteredEntities, searchTerm } = this.state;
    const noResults = searchTerm && filteredEntities.length < 1;
    return (
      <PageRoot>
        <PageHeader
          breadcrumbLinks={[
            {
              label: routes.HOME.label,
              route: routes.HOME.url
            }
          ]}
          label={routes.MY_LEGAL_ENTITIES.label}
        />
        <DetailGrid
          details={this.formatDetails(
            searchTerm ? filteredEntities : legalEntities
          )}
          onSubmitSearch={this.onSearch}
          btnDisabled={this.props.loading}
        />
        {noResults && (
          <Card className={classes.noResults}>
            <Typography align="center" color="primary" variant="h5">
              {`Oops, no results matching "${searchTerm}"`}
            </Typography>
          </Card>
        )}
      </PageRoot>
    );
  }
}

const mapDispatchToProps = {
  getLegalEntities: legalEntityActions.getLegalEntities
};

const mapStateToProps = ({ legalEntity }: any) => {
  return {
    legalEntities: legalEntity.legalEntities,
    loading: legalEntity.loading
  };
};

export const styled = withStyles(styles)(MyLegalEntities);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled);
